// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"160a6cde7f7682d779b6","655":"7570833e1e7867701618"}[chunkId] + ".js";
};